import React from "react";
import { motion } from "framer-motion";

const socialLinks = [
  { label: "LinkedIn", href: "https://www.linkedin.com/in/seanfee/", rel: "noopener noreferrer me" },
  { label: "Twitter", href: "https://x.com/seanfee", rel: "noopener noreferrer me" },
  { label: "Legend", href: "https://legendhq.com", rel: "noopener noreferrer" },
  { label: "XSplit", href: "https://xsplit.com", rel: "noopener noreferrer" },
  { label: "Challonge", href: "https://challonge.com", rel: "noopener noreferrer" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative py-16 px-6 md:px-12 lg:px-24 border-t border-white/[0.05]" role="contentinfo">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 mb-10">
          <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>
            <p className="text-lg text-white italic mb-1" data-testid="footer-brand">Sean Fee</p>
            <p className="text-xs text-white/30 max-w-xs" style={{ fontFamily: "system-ui, sans-serif" }}>
              Entrepreneur, advisor and investor building companies that help people share their passion with the world.
            </p>
          </motion.div>

          <motion.nav initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="flex items-center gap-8" aria-label="Footer navigation">
            {["home", "about", "projects", "contact"].map((section) => (
              <a
                key={section}
                href={`#${section}`}
                data-testid={`footer-link-${section}`}
                className="text-xs uppercase tracking-[0.15em] text-white/30 hover:text-white/60 transition-colors link-underline"
                style={{ fontFamily: "system-ui, sans-serif" }}
                onClick={(e) => {
                  e.preventDefault();
                  if (section === "home") window.scrollTo({ top: 0, behavior: "smooth" });
                  else document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </a>
            ))}
          </motion.nav>
        </div>

        <div className="section-divider mb-8" aria-hidden="true" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="text-xs uppercase tracking-[0.2em] text-white/20" style={{ fontFamily: "system-ui, sans-serif" }} data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} Sean Fee. All rights reserved.
          </motion.p>
          <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="flex items-center gap-6" aria-label="External project links">
            {socialLinks.map((link) => (
              <a key={link.label} href={link.href} target="_blank" rel={link.rel} data-testid={`footer-social-${link.label.toLowerCase()}`} className="text-[10px] uppercase tracking-[0.15em] text-white/20 hover:text-white/50 transition-colors" style={{ fontFamily: "system-ui, sans-serif" }}>
                {link.label}
              </a>
            ))}
          </motion.div>
        </div>
      </div>
    </footer>
  );
}
